import React from 'react';
import { motion } from 'framer-motion';
import '../styles/home.css';


export default function Home() {
  return (
    <div className="tpa-root">
      <header className="hero">
        <div className="hero-inner container">
          <div className="hero-left">
            <motion.h1
              className="brand-title"
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.6, ease: 'easeOut' }}
            >
              TPA Bricks — Built To Last
            </motion.h1>
            <motion.h2
  className="brand-subtitle"
  initial={{ y: 20, opacity: 0 }}
  animate={{ y: 0, opacity: 1 }}
  transition={{ delay: 0.15, duration: 0.6 }}
>
  Box Bricks & Hand-Made Bricks
</motion.h2>

            <motion.p
              className="lead"
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.12, duration: 0.6 }}
            >
              Industrial strength. Timeless finish. Engineered using
              traditional methods with modern QA — bricks that hold up
              through generations.
            </motion.p>

            <motion.div
              className="hero-cta"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              <a href="#sizes" className="btn-primary">Explore Sizes</a>
              <a href="/contact" className="btn-ghost">Get a Quote</a>
            </motion.div>

            <motion.ul
              className="stats"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
            >
              
              <li>
                <strong>50+</strong>
                <span>Years</span>
              </li>
              <li>
                <strong>200k+</strong>
                <span>Bricks/month</span>
              </li>
              <li>
                <strong>Statewide</strong>
                <span>Delivery</span>
              </li>
            </motion.ul>
          </div>

          <div className="hero-right">
            <motion.div
              className="image-stack"
              initial={{ scale: 0.98, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.15, duration: 0.6 }}
            >
              <div className="image-card image-card-1">
                <img src="/tpa3.jpg" alt="TPA bricks closeup" />
              </div>
              <div className="image-card image-card-2">
                <img src="/tpa7.png" alt="Stack of bricks" />
              </div>
            </motion.div>
          </div>
        </div>
      </header>

      <section id="sizes" className="section sizes">
        <div className="container">
          <motion.h2
            className="section-title"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Bricks & Sizes
          </motion.h2>

          <motion.div
            className="sizes-grid"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.12 }}
          >
            {/* Repeat each card for different sizes */}
            <article className="card size-card">
              <div className="card-media">
                <img src="/new4.jpg" alt="6 inch brick" />
              </div>
              <div className="card-body">
                <h3>9 inch</h3>
                <p>Width: <strong>4.1</strong> &nbsp; Height: <strong>3.2</strong></p>
                {/* <a className="card-cta" href="#contact">Order Sample</a> */}
              </div>
            </article>

            <article className="card size-card">
              <div className="card-media">
                <img src="/new1.jpg" alt="9 inch brick"/>
              </div>
              <div className="card-body">
                    <h3>9 inch</h3>
                <p>Width: <strong>4.1</strong> &nbsp; Height: <strong>3.2</strong></p>
                {/* <a className="card-cta" href="#contact">Order Sample</a> */}
              </div>
            </article>

            <article className="card size-card">
              <div className="card-media">
                <img src="/ss6.png" alt="standard brick" />
              </div>
              <div className="card-body">
                <h3>Standard</h3>
                    <h3>9 inch</h3>
                <p>Width: <strong>4.1</strong> &nbsp; Height: <strong>3.2</strong></p>
                {/* <a className="card-cta" href="#contact">Order Sample</a> */}
              </div>
            </article>
          </motion.div>
        </div>
      </section>


      {/* <footer id="contact" className="footer">
        <div className="container footer-inner">
          <div>
            <h3>Get in touch</h3>
            <p>Email: sales@tpabricks.com</p>
            <p>Phone: +91 98765 43210</p>
          </div>
{/* 
          <div className="socials">
            <a href="#">LinkedIn</a>
            <a href="#">Instagram</a>
            <a href="#">WhatsApp</a>
          </div> */}
        {/* </div> */}
        {/* <div className="attribution">© {new Date().getFullYear()} TPA Bricks</div> */}
      {/* // </footer> */} 
    </div>
  );
}